import { IAdvertising } from "api/types/_advertising";
import { IAgency } from "api/types/_agency";
import { ICoupang } from "api/types/_coupang";
import { IInventory, ITypeInventory } from "api/types/_inventory";
import { IMedia } from "api/types/_media";
import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import DropdownAgency from "components/Common/DropdownAgency";
import DropdownMedia from "components/Common/DropdownMedia";
import DropdownOption from "components/Common/DropdownOption";
import DropdownStatus from "components/Common/DropdownStatus";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableInventory from "components/Common/TableInventory";
import { useRole } from "components/Hooks/UserHooks";
import { AD_PLATFORM_INVENTORY_OPTIONS, AD_PLATFORM_INVENTORY_TYPE_DIGITAL_CAMP, AD_TYPE_INVENTORY_OPTIONS, ARRAY_CONFIG_DISPLAY_INVENTORY_LIST, BANNER_TYPE_INVENTORY_OPTIONS, POSITION_INVENTORY_OPTIONS, STATUS_INVENTORY_OPTIONS, TYPE_ADS_DEVICE_OPTIONS, TYPE_MEDIA_OPTIONS } from "helpers/constans";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Modal, ModalBody, ModalHeader, Offcanvas, OffcanvasBody, OffcanvasHeader, Row, Spinner, } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from "use-query-params";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import { deleteInventory, getAllAdvertising, getAllAgencies, getAllCoupangs, getAllDomains, getAllInventories, getAllMedias, getAllTypeInventories, getConfigDisplayInventory as onGetConfigDisplayInventory, getInventories as onGetInventories, updateConfigInventory, updateMemoInventory } from "../../../store/thunks";
import AssignAutomaticRedirect from "./AssignAutomaticRedirect";
import ConfigInventoryCPM from "./ConfigInventoryCPM";
import FormInventory from "./FormInventory";
import InventoryHistory from "./InventoryHistory";
import ConfigAgencyCPM from "./ConfigAgencyCPM";
import TypeInventory from "./TypeInventory";
import ConfigDisplayInventory from "./ConfigDisplayInventory";
import { IDomain } from "api/types/_domain";
import { formatNumberWithCommas } from "helpers/format";
import ModalCommonSetting from "./Modal CommonSetting";

const SORT_BY_DEFAULT = 'id';
const ORDER_BY_DEFAULT = 'DESC';
const MAX_WIDTH_SCREEN = 1800;
const ManagementInventory = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const navigate = useNavigate();

    const STATUS_INVENTORY_OPTIONS_LANG = STATUS_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const POSITION_INVENTORY_OPTIONS_LANG = POSITION_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const DEVICE_OPTIONS_LANG = TYPE_ADS_DEVICE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const TYPE_INVENTORY_OPTIONS_LANG = [{ value: '1', label: 'Main' }, { value: '2', label: 'Sub' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const STATUS_SETTING_OPTIONS_LANG = [{ value: '1', label: 'Applied' }, { value: '0', label: 'Not Applied' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const AD_PLATFORM_INVENTORY_OPTIONS_LANG = AD_PLATFORM_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const AD_TYPE_INVENTORY_OPTIONS_LANG = AD_TYPE_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const BANNER_TYPE_INVENTORY_OPTIONS_LANG = BANNER_TYPE_INVENTORY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const STATUS_FORCE_CLICK_OPTIONS_LANG = [{ value: '1', label: 'Applied' }, { value: '0', label: 'Not Applied' }]?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const TYPE_MEDIA_OPTIONS_LANG = TYPE_MEDIA_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 50),
        sort_by: withDefault(StringParam, SORT_BY_DEFAULT),
        order_by: withDefault(StringParam, ORDER_BY_DEFAULT),
        // name: withDefault(StringParam, ''),
        status: withDefault(StringParam, STATUS_INVENTORY_OPTIONS_LANG[1]?.value),
        media_code: withDefault(StringParam, ''),
        // add_type: withDefault(StringParam, ''),
        // device: withDefault(StringParam, ''),
        // agency_code: withDefault(StringParam, ''),
        // inventory_type: withDefault(StringParam, TYPE_INVENTORY_OPTIONS_LANG[0]?.value),
        // inventory_type_id: withDefault(StringParam, ''),
        // fill_rate: withDefault(StringParam, ''),
        // flg_banner_size: withDefault(StringParam, ''),
        // flg_click: withDefault(StringParam, ''),
        // is_block_referral: withDefault(StringParam, ''),
        // is_except_keyword: withDefault(StringParam, ''),
        // automatic_click: withDefault(StringParam, ''),
        // ad_type: withDefault(StringParam, ''),
        // banner_type: withDefault(StringParam, ''),
        // ad_platform: withDefault(StringParam, ''),
        // tracking_code: withDefault(StringParam, ''),
        // sub_id: withDefault(StringParam, ''),
        // domain_id: withDefault(StringParam, ''),

    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.Management;

    const ManagementProperties = createSelector(
        selectLayoutState,
        (state) => ({
            inventories: state.inventories,
            isInventorySuccess: state.isInventorySuccess,
            isInventoryLoading: state.isInventoryLoading,
            configDisplayInventory: state.configDisplayInventory,
            error: state.error,
        })
    );

    const { inventories, isInventoryLoading, configDisplayInventory } = useSelector(ManagementProperties);
    const [isCallAllOptionLoading, setIsCallAllOptionLoading] = useState<boolean>(true);

    const [nameSearch, setNameSearch] = useState<string>(query?.name || "");

    const [listDomain, setListDomain] = useState<IDomain[]>([]);

    const [listMedia, setListMedia] = useState<IMedia[]>([]);

    const [mediaSearch, setMediaSearch] = useState<Option | null>({
        label: listMedia?.filter((item) => String(item?.code || '') === String(query?.media_code || ''))[0]?.name || t('All'),
        value: `${listMedia?.filter((item) => String(item?.code || '') === String(query?.media_code || ''))[0]?.code || ''}`
    });

    const [mediaTypeSearch, setMediaTypeSearch] = useState<Option | null>(TYPE_MEDIA_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.add_type)) || null);

    const [listAgency, setListAgency] = useState<IAgency[]>([]);
    const [agencySearch, setAgencySearch] = useState<Option | null>({
        label: listAgency?.find((item) => String(item?.code || '') === String(query?.agency_code || ''))?.name || t('All'),
        value: `${listAgency?.find((item) => String(item?.code || '') === String(query?.agency_code || ''))?.code || ''}`
    });

    const [listTypeInventory, setListTypeInventory] = useState<ITypeInventory[]>([]);
    const [typeInventorySearch, setTypeInventorySearch] = useState<Option | null>({
        label: listTypeInventory?.find((item) => String(item?.id || '') === String(query?.inventory_type_id || ''))?.title || t('All'),
        value: `${listTypeInventory?.find((item) => String(item?.id || '') === String(query?.inventory_type_id || ''))?.id || ''}`
    });

    const [domainSearch, setDomainSearch] = useState<Option | null>({
        label: listDomain?.find((item) => String(item?.id || '') === String(query?.domain_id || ''))?.domain || t('All'),
        value: `${listDomain?.find((item) => String(item?.id || '') === String(query?.domain_id || ''))?.id || ''}`
    });

    const [optionsSelected, setOptionsSelected] = useState<any>([]);

    const [listCoupang, setListCoupang] = useState<ICoupang[]>([]);

    const [listInventory, setListInventory] = useState<IInventory[]>([]);

    const [listAdvertising, setListAdvertising] = useState<IAdvertising[]>([]);

    const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.status))[0]);

    const [deviceSearch, setDeviceSearch] = useState<Option | null>(DEVICE_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.device))[0]);

    const [typeSearch, setTypeSearch] = useState<Option | null>(TYPE_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.inventory_type))[0]);

    const [adTypeSearch, setAdTypeSearch] = useState<Option | null>(AD_TYPE_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.ad_type))[0]);

    const [bannerTypeSearch, setBannerTypeSearch] = useState<Option | null>(BANNER_TYPE_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.banner_type))[0]);

    const [adPlatformSearch, setAdPlatformSearch] = useState<Option | null>(AD_PLATFORM_INVENTORY_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.ad_platform))[0]);

    const [fillRateSearch, setFillRateSearch] = useState<Option | null>(STATUS_SETTING_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.fill_rate))[0]);
    const [flgBannerSizeSearch, setFlgBannerSizeSearch] = useState<Option | null>(STATUS_SETTING_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.flg_banner_size))[0]);
    const [flgClickSearch, setFlgClickSearch] = useState<Option | null>(STATUS_SETTING_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.flg_click))[0]);
    const [isBlockReferralSearch, setIsBlockReferralSearch] = useState<Option | null>(STATUS_SETTING_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.is_block_referral))[0]);
    const [isExceptKeywordSearch, setIsExceptKeywordSearch] = useState<Option | null>(STATUS_SETTING_OPTIONS_LANG?.filter((item) => String(item?.value) === String(query?.is_except_keyword))[0]);

    const [isAutomaticClickSearch, setIsAutomaticClickSearch] = useState<Option | null>(STATUS_FORCE_CLICK_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.automatic_click)) || null);

    const [subIdSearch, setSubIdSearch] = useState<string>(query?.sub_id);
    const [trackingCodeSearch, setTrackingCodeSearch] = useState<string>(query?.tracking_code);

    const [inventoryDetail, setInventoryDetail] = useState<IInventory | null>(null);

    const [inventoryHistories, setInventoryHistories] = useState<IInventory | null>(null);

    const [idDelete, setIdDelete] = useState<number | null>(null);
    const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

    const [isShowModalAssignAutomaticRedirect, setIsShowModalAssignAutomaticRedirect] = useState<boolean>(false);

    const [isShowModalCommonSetting, setIsShowModalCommonSetting] = useState<boolean>(false);

    const [isShowConfigDisplayInventory, setIsShowConfigDisplayInventory] = useState<boolean>(false);

    const [isShowModalTypeManagement, setIsShowModalTypeManagement] = useState<boolean>(false);

    const [inventoryShowCPM, setInventoryShowCPM] = useState<any>(null);

    const [windowSize, setWindowSize] = useState<{ width: number, height: number }>({ width: 0, height: 0 });

    const [isEditMultiInventory, setIsEditMultiInventory] = useState<boolean>(false);

    useEffect(() => {
        dispatch(onGetInventories(query));
    }, [JSON.stringify(query)]);

    useEffect(() => {
        dispatch(onGetConfigDisplayInventory({ type: 'inventories' }));
    }, []);

    const searchData = () => {
        setQuery({
            ...query,
            page: 1,
            name: nameSearch || '',
            status: statusSearch?.value || '',
            // device: deviceSearch?.value || '',
            // inventory_type: typeSearch?.value || '',
            media_code: mediaSearch?.value || '',
            // add_type: mediaTypeSearch?.value || '',
            // agency_code: agencySearch?.value || '',
            // inventory_type_id: typeInventorySearch?.value || '',
            // fill_rate: fillRateSearch?.value || '',
            // flg_banner_size: flgBannerSizeSearch?.value || '',
            // flg_click: flgClickSearch?.value || '',
            // is_block_referral: isBlockReferralSearch?.value || '',
            // is_except_keyword: isExceptKeywordSearch?.value || '',
            // automatic_click: isAutomaticClickSearch?.value || '',
            // ad_type: adTypeSearch?.value || '',
            // banner_type: bannerTypeSearch?.value || '',
            // ad_platform: adPlatformSearch?.value || '',
            // tracking_code: trackingCodeSearch || '',
            // sub_id: subIdSearch || '',
            // domain_id: domainSearch?.value || '',
            time_request: + new Date()
        });

        // Clear options selected
        setOptionsSelected((_prev: any) => []);
    };

    const resetData = () => {
        setQuery({
            name: '',
            status: STATUS_INVENTORY_OPTIONS_LANG[1]?.value,
            device: '',
            media_code: '',
            add_type: '',
            agency_code: '',
            inventory_type_id: '',
            inventory_type: TYPE_INVENTORY_OPTIONS_LANG[0]?.value,
            fill_rate: '',
            flg_banner_size: '',
            flg_click: '',
            is_block_referral: '',
            is_except_keyword: '',
            automatic_click: '',
            ad_type: '',
            banner_type: '',
            ad_platform: '',
            tracking_code: '',
            sub_id: '',
            domain_id: '',
            sort_by: SORT_BY_DEFAULT,
            order_by: ORDER_BY_DEFAULT,
            time_request: + new Date(),
            page: 1,
        }, "push");
        setNameSearch("");
        setStatusSearch(STATUS_INVENTORY_OPTIONS_LANG[1]);
        setMediaSearch({ label: t('All'), value: '' });
        setDeviceSearch({ label: t('All Device'), value: '' });
        setAgencySearch({ label: t('All'), value: '' });
        setTypeInventorySearch({ label: t('All'), value: '' });
        setTypeSearch(TYPE_INVENTORY_OPTIONS_LANG[0]);
        setAdTypeSearch({ label: t('All'), value: '' });
        setBannerTypeSearch({ label: t('All'), value: '' });
        setAdPlatformSearch({ label: t('All'), value: '' });

        setFillRateSearch({ label: t('All Setting'), value: '' });
        setFlgBannerSizeSearch({ label: t('All Setting'), value: '' });
        setFlgClickSearch({ label: t('All Setting'), value: '' });
        setIsBlockReferralSearch({ label: t('All Setting'), value: '' });
        setIsExceptKeywordSearch({ label: t('All Setting'), value: '' });
        setIsAutomaticClickSearch({ label: t('All'), value: '' });
        setMediaTypeSearch({ label: t('All'), value: '' });
        setDomainSearch({ label: t('All'), value: '' });

        setSubIdSearch("");
        setTrackingCodeSearch("");


        // Clear options selected
        setOptionsSelected((_prev: any) => []);
    };

    const handleRefreshAllInventories = async () => {
        try {
            const [resInventory]: any = await Promise.all([getAllInventories()]);
            const list_i = (resInventory?.data || []);
            setListInventory((_prev) => list_i);
        } catch (error: any) {
            return error;
        }
    }

    const handleRefreshAllCoupangs = async () => {
        try {
            const [resCoupang]: any = await Promise.all([getAllCoupangs()]);
            const list_c = (resCoupang?.data || []);
            setListCoupang((_prev) => list_c);
        } catch (error: any) {
            return error;
        }
    }


    const handleRefresh = (TYPE_ACTION: string = '') => {
        try {
            // setIsShowModalAssignAutomaticRedirect((_prev) => false);
            handleCloseModalFormInventory();
            setQuery({ ...query, time_request: + new Date() }, "push");
            handleRefreshAllInventories();
            handleRefreshAllCoupangs();
            if (TYPE_ACTION === 'EDIT_MULTI_INVENTORY') {
                setOptionsSelected((_prev: any) => []);
                setIsEditMultiInventory((_prev) => false);
                if (windowSize?.width >= MAX_WIDTH_SCREEN) {
                    //Because the offcanvas is not closed immediately, so we need to wait for the offcanvas to close
                    setTimeout(() => {
                        document.body.style.removeProperty('overflow');
                        document.body.style.removeProperty('padding-right');
                    }, 800);
                }
            }
        } catch (error: any) {
            return error;
        }
    }

    const handleRefreshTypeInventory = async () => {
        try {
            const [resTypeInventory]: any = await Promise.all([getAllTypeInventories()]);
            const list_t = resTypeInventory?.data || [];
            const type = list_t?.find((item: any) => String(item?.id || '') === String(query?.inventory_type_id || '')) || null;
            setListTypeInventory((_prev) => list_t);
            setTypeInventorySearch((_prev) => ({
                label: type?.title || t('All'),
                value: type?.id || '',
            }));
        } catch (error: any) {
            return error;
        }
    }

    const handleCloseModalFormInventory = () => {
        setIsEditMultiInventory((_prev) => false);
        setInventoryDetail((_prev) => null);
    };

    // Begin:: update config inventory
    interface IItemUpdateConfig {
        id: number;
        data: { status?: number, flg_click?: number, flg_banner_size?: number, fill_rate?: number, block_internal?: number, is_block_referral?: number, is_except_keyword?: number, except_general_visitors?: number, automatic_click?: number, automatic_redirect?: number, popup_automatic_click?: number };
    };
    const [itemUpdate, setItemUpdate] = useState<IItemUpdateConfig | null>(null);
    const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);
    const handleShowConfirmUpdateConfig = (item: IItemUpdateConfig | null) => {
        setItemUpdate(item);
    };
    const handleOnConfirmUpdate = async () => {
        try {
            if (!itemUpdate) {
                return;
            }
            setIsLoadingUpdate((_prev) => true);
            const response: any = await updateConfigInventory(itemUpdate?.id, itemUpdate?.data);
            setIsLoadingUpdate((_prev) => false);
            if (response?.code === 200) {
                setItemUpdate((_prev) => null);
                dispatch(onGetInventories(query));
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoadingUpdate((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }
    // End:: update config inventory

    const isValueWithKey = useCallback((_key: string) => {
        const _keys = String(_key)?.split('*') || [];
        const _v = (configDisplayInventory?.[`${_keys[0]}`])?.find((_c: { field: string, value: number }) => (_c?.field === `${_keys?.[1]}`))?.value || 0;
        return _v;
    }, [JSON.stringify(configDisplayInventory)]);

    const getValueWithKey = useCallback((_key: string, __configs: any) => {
        const _keys = String(_key)?.split('*') || [];
        const _v = (__configs?.[`${_keys[0]}`])?.find((_c: { field: string, value: number }) => (_c?.field === `${_keys?.[1]}`));
        return _v;
    }, []);


    // Begin:: handle select table 

    const full_items = useMemo(() => {
        return (inventories?.list || [])?.reduce((arr: any, item: any) => ([
            ...arr,
            { value: item?.id, label: item?.id }, ...((item?.subs || [])?.map((_sub: any) => ({ value: _sub?.id, label: _sub?.id })))
        ]), []);
    }, [JSON.stringify(inventories)]);

    const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
        // if (!!isFirstLoadingPageRef.current) {
        //     return;
        // }
        const index = String(valueIndex);
        if (valueCheck?.value === 'ALL') {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (e.target.checked) {
                    if (prevClone[index] === undefined) {
                        prevClone[index] = [];
                    }
                    prevClone[index] = full_items;
                    return prevClone;
                } else {
                    prevClone[index] = [];
                    return prevClone;
                }
            });
            return;
        }
        if (!e.target.checked) {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
                return prevClone;
            });
        } else {
            setOptionsSelected((prev: any) => {
                const prevClone = structuredClone(prev);
                if (prevClone[index] === undefined) {
                    prevClone[index] = [];
                }
                prevClone[index] = ([...prevClone[index], valueCheck]);
                return prevClone;
            });
        }
    };

    const isChecked = (valueCheck: Option) => {
        const index = String(query.page);
        return !!(optionsSelected[index]?.find((x: any) => String(x?.value) === String(valueCheck?.value))?.value);
    };

    const isCheckedAll = (valueIndex: string) => {
        const valueIndexString = String(valueIndex);
        return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === full_items?.length);
    };

    const countRowSelected = useMemo(() => {
        return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
            return Number(total + (value || [])?.length);
        }, 0)
    }, [optionsSelected]);

    const optionsSelectedValue = useMemo(() => {
        const _ids = (optionsSelected || []).flat()?.map((item: any) => Number(item?.value));
        return _ids;
    }, [optionsSelected]);

    // Column
    const columns = useMemo(
        () => {
            const returnColumnByKey = (_key: string) => {
                switch (_key) {
                    case "inventories*checkbox":
                        return ({
                            Header: '',
                            accessor: "checkbox",
                            filterable: false,
                            sortable: false,
                            thWidth: 60,
                            thClass: 'text-center',
                            thComponent: () => (
                                <>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
                                        <label className="form-check-label" htmlFor={`cell-check-all`}></label>
                                    </div>
                                </>
                            ),
                            Cell: (cell: any) => (
                                <div style={{ width: '40px' }}></div>
                            ),
                        });
                    case "inventories*id":
                        return ({
                            Header: t('ID'),
                            accessor: "id",
                            filterable: false,
                            sortable: true,
                            thWidth: 60,
                            Cell: (cell: any) => (
                                <div style={{ width: '60px' }}></div>
                            ),
                        });
                    case "inventories*media_code":
                        return ({
                            Header: t('Media'),
                            accessor: "media",
                            filterable: false,
                            sortable: false,
                            thWidth: 250,
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                const media = cell?.value;
                                return (<></>)
                            },
                        });
                    case "inventories*name":
                        return ({
                            Header: t('Inventory'),
                            accessor: "attributes",
                            filterable: false,
                            sortable: false,
                            thWidth: 250,
                            Cell: (cell: any) => {
                                return (
                                    <>
                                        <div className="d-flex align-items-center" style={{ width: '190px' }}>
                                        </div>
                                    </>
                                )
                            },
                        });
                    case "inventories*status":
                        return ({
                            Header: t('Status'),
                            accessor: "status",
                            filterable: false,
                            sortable: false,
                            thWidth: 85,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '75px' }}>
                                    </div>
                                )
                            },
                        });
                    case "attributes*integration_method":
                        return ({
                            Header: t('Integration Method'),
                            accessor: "integration_method",
                            filterable: false,
                            sortable: false,
                            thWidth: 170,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '170px' }}>
                                    </div>
                                )
                            },
                        });
                    case "attributes*button_position":
                        return ({
                            Header: t('Close Button'),
                            accessor: "button",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            Cell: (cell: any) => {
                                return (
                                    <>
                                        <div className="d-flex align-items-center" style={{ width: '130px' }}>
                                        </div>
                                    </>
                                )
                            },
                        });
                    case "inventories*cpm":
                        return ({
                            Header: t('CPM'),
                            accessor: "cpm",
                            filterable: false,
                            sortable: false,
                            thWidth: 100,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <>
                                        <div className="d-flex align-items-center" style={{ width: '80px' }}>
                                        </div>
                                    </>
                                )
                            },
                        });
                    case "inventories*code":
                        return ({
                            Header: t('Agency'),
                            accessor: "agency",
                            filterable: false,
                            sortable: false,
                            thWidth: 100,
                            thClass: 'text-center',
                            Cell: (cell: any) => (
                                <></>
                            ),
                        });
                    case "inventories*group_code":
                        return ({
                            Header: t('Agency CPM'),
                            accessor: "agency_cpm",
                            filterable: true,
                            sortable: false,
                            thWidth: 110,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <></>
                                )
                            },
                        });
                    case "configs*fill_rate":
                        return ({
                            Header: t('Fill-Rate'),
                            accessor: "fill_rate",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 120,
                            description: t('Ad is displayed once every hour'),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '110px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*flg_click":
                        return ({
                            Header: t('Click Option'),
                            accessor: "configs.flg_click",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 130,
                            description: t('When incoming from an external URL, click on the advertisement'),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '120px' }}>
                                    </div>
                                )
                            },
                        });
                    case "configs*flg_banner_size":
                        return ({
                            Header: t('Size Option'),
                            accessor: "configs.flg_banner_size",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 130,
                            description: t('When incoming from an external URL, change the banner size'),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '120px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*block_internal":
                        return ({
                            Header: t('Block Internal'),
                            accessor: "block_internal",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 140,
                            description: t("When the referral URL is an internal URL, the 'Click Option' and 'Size Option' do not work"),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '130px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*is_block_referral":
                        return ({
                            Header: t('Block Referral'),
                            accessor: "is_block_referral",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 140,
                            description: t("If the referral is empty or main, it's now shown ad"),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '130px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*is_except_keyword":
                        return ({
                            Header: t('Block Keyword'),
                            accessor: "is_except_keyword",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 140,
                            description: t("If specific keywords is included in referral url, we show ad but it's not working 'Click Option', 'Size Option', only working normally in any cases."),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '130px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*except_general_visitors":
                        return ({
                            Header: t('Except Automatic'),
                            accessor: "except_general_visitors",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 160,
                            description: t("Automatically except UUIDs that have no referrers and exceed the specified number of impression during the designated period."),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '150px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*automatic_click":
                        return ({
                            Header: t('Force Click (Layer & Slider)'),
                            accessor: "automatic_click",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 220,
                            description: t("For self-advertisements, clicking around the ad also counts as clicking the ad. In the case of Slider Banner V2, touching it triggers the ad click."),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '150px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    case "configs*popup_automatic_click":
                        return ({
                            Header: t('Automatic Click (Popup)'),
                            accessor: "popup_automatic_click",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 200,
                            description: t("Ads will be auto-clicked based on a specified probability (the popup may be blocked)."),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '180px' }} className="position-relative">
                                    </div>
                                )
                            },
                        });
                    // case "configs*automatic_redirect":
                    //     return ({
                    //         Header: t('Automatic Redirect'),
                    //         accessor: "automatic_redirect",
                    //         filterable: false,
                    //         sortable: false,
                    //         thClass: 'text-center',
                    //         thWidth: 170,
                    //         description: t("If the script installation type is set to 'normal,' it will function by automatically redirecting the user to the specified redirect URL if no click occurs within the designated time frame of 24 hours."),
                    //         Cell: (cell: any) => {
                    //             const item = cell?.row?.original;
                    //             return (
                    //                 <div style={{ minWidth: '160px' }} className="position-relative">
                    //                 </div>
                    //             )
                    //         },
                    //     });
                    case "configs*limit_ads":
                        return ({
                            Header: t('Impression limitation per user'),
                            accessor: "limit_ads",
                            filterable: false,
                            sortable: false,
                            thWidth: 250,
                            thClass: 'text-center',
                            description: t("Ads are limited to one impression per user per day; if set to 0, they will display without restriction."),
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                const configs = item?.configs || null;
                                return (
                                    <>
                                        <div className="text-center" style={{ minWidth: '100px' }}></div>
                                    </>
                                );
                            },
                        });
                    case "inventories*ad_tracking_code":
                        return ({
                            Header: t('Tracking Code'),
                            accessor: "ad_tracking_code",
                            filterable: false,
                            sortable: false,
                            thWidth: 160,
                            Cell: (cell: any) => (
                                <div style={{ minWidth: '150px' }}>
                                </div>
                            ),
                        });
                    case "inventories*ad_sub_id":
                        return ({
                            Header: t('Sub ID'),
                            accessor: "ad_sub_id",
                            filterable: false,
                            sortable: false,
                            thWidth: 170,
                            Cell: (cell: any) => (
                                <>
                                    <div style={{ minWidth: '160px' }} >
                                    </div>
                                </>
                            ),
                        });
                    case "inventories*ad_id":
                        return ({
                            Header: t('Ad ID'),
                            accessor: "ad_id",
                            filterable: false,
                            sortable: false,
                            thWidth: 110,
                            Cell: (cell: any) => (
                                <>
                                    <div style={{ minWidth: '100px' }}>
                                    </div>
                                </>
                            ),
                        });
                    case "inventories*script_url":
                        return ({
                            Header: t('Script Url'),
                            accessor: "script_url",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 150,
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div style={{ minWidth: '140px' }} >
                                    </div>
                                )
                            },
                        });
                    case "inventories*version":
                        return ({
                            Header: t('Version'),
                            accessor: "version",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div className="text-center">
                                    </div>
                                )
                            },
                        });
                    case "inventories*ad_type":
                        return ({
                            Header: t('Ad Type'),
                            accessor: "ad_type",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '100px' }}>
                                    </div>
                                )
                            },
                        });
                    case "inventories*banner_type":
                        return ({
                            Header: t('Banner Type'),
                            accessor: "banner_type",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '100px' }}>
                                    </div>
                                )
                            },
                        });
                    case "inventories*inventory_type_id":
                        return ({
                            Header: t('Type Of Inventory In Filter'),
                            accessor: "inventory_type_id",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '100px' }}>
                                    </div>
                                )
                            },
                        });
                    case "inventories*domain_id":
                        return ({
                            Header: t('Domain'),
                            accessor: "domain",
                            filterable: false,
                            sortable: false,
                            thWidth: 150,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                return (
                                    <div className="text-center" style={{ minWidth: '100px' }}>
                                    </div>
                                )
                            },
                        });
                    case "inventories*memo":
                        return ({
                            Header: t('Memo'),
                            accessor: "memo",
                            filterable: false,
                            sortable: false,
                            thClass: 'text-center',
                            thWidth: 150,
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                return (
                                    <div className="text-start d-flex justify-content-end align-items-center w-100 position-relative" style={{ minWidth: '130px', maxWidth: '200px' }}>
                                    </div>
                                )
                            },
                        });
                    case "configs*hidden_ads_count":
                        return ({
                            Header: t('Additional Ad'),
                            accessor: "hidden_ads_count",
                            filterable: false,
                            sortable: false,
                            thWidth: 140,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                const configs = item?.configs || null;
                                return (
                                    <>
                                        <div className="text-center" style={{ minWidth: '120px' }}></div>
                                    </>
                                );
                            },
                        });
                    case "configs*target_ctr":
                        return ({
                            Header: t('Target CTR'),
                            accessor: "target_ctr",
                            filterable: false,
                            sortable: false,
                            thWidth: 100,
                            thClass: 'text-center',
                            Cell: (cell: any) => {
                                const item = cell?.row?.original;
                                const configs = item?.configs || null;
                                return (
                                    <>
                                        <div className="text-center" style={{ minWidth: '80px' }}></div>
                                    </>
                                );
                            },
                        });
                    case "inventories*created_at":
                        return ({
                            Header: t('Created at'),
                            accessor: "created_at",
                            filterable: true,
                            sortable: false,
                            thWidth: 120,
                            thClass: 'text-end',
                            Cell: (cell: any) => {
                                const arrDate = String(cell?.value || '').split(' ');
                                return (
                                    <div className="text-end" style={{ minWidth: '100px' }}>

                                    </div>
                                )
                            },
                        });
                    case "inventories*updated_at":
                        return ({
                            Header: t('Updated at'),
                            accessor: "updated_at",
                            filterable: true,
                            sortable: false,
                            thWidth: 120,
                            thClass: 'text-end',
                            Cell: (cell: any) => {
                                const arrDate = String(cell?.value || '').split(' ');
                                return (
                                    <div className="text-end" style={{ minWidth: '100px' }}>

                                    </div>
                                )
                            },
                        });
                    case "inventories*installation_date":
                        return ({
                            Header: t('Installed at'),
                            accessor: "installation_date",
                            filterable: true,
                            sortable: false,
                            thWidth: 120,
                            thClass: 'text-end',
                            Cell: (cell: any) => {
                                const arrDate = String(cell?.value || '').split(' ');
                                return (
                                    <div className="text-end" style={{ minWidth: '100px' }}>

                                    </div>
                                )
                            },
                        });
                    case "inventories*key":
                        return ({
                            Header: t('Action'),
                            thClass: 'text-end pe-6',
                            thWidth: 200,
                            Cell: (cell: any) => {
                                const item: any = cell?.row?.original;
                                return (
                                    <div className="text-center" style={{ minWidth: '120px' }}>
                                        <ul className="list-inline justify-content-center hstack gap-2 mb-0">

                                        </ul>
                                    </div>
                                );
                            },
                        });
                    default:
                        return <></>;

                }
            };

            const _cols = (ARRAY_CONFIG_DISPLAY_INVENTORY_LIST)?.map((_i) => {
                const _v = getValueWithKey(_i?.key, configDisplayInventory);
                return ({
                    ..._i,
                    value: _v?.value,
                    sort: _v?.sort,
                });
            }).sort((a, b) => a?.sort - b?.sort)?.filter((a) => !!a?.value);

            return [..._cols]?.map((_c) => returnColumnByKey(_c?.key));

        }, [i18n?.language, JSON.stringify(query), JSON.stringify(configDisplayInventory), JSON.stringify(optionsSelected), JSON.stringify(full_items)]);

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    // Begin::Delete
    const handleConfirmDelete = (item: IInventory) => {
        setIdDelete((_prev) => item?.id);
    };

    const handleActionDelete = async () => {
        if (!idDelete) { return; };
        try {
            setIsConfirmLoading((_prev) => true);
            const response: any = await deleteInventory(idDelete);
            if (response?.code === 200) {
                dispatch(onGetInventories(query));
                setIsConfirmLoading((_prev) => false);
                setIdDelete((_prev) => null);
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
                handleRefreshAllInventories();
            } else {
                setIsConfirmLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsConfirmLoading((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const onCloseConfirmClick = () => {
        setIdDelete((_prev) => null);
    }
    // End::Delete

    const handleCreateSubInventoryFrom = (item: IInventory) => {
        const cloneInventory: any = structuredClone(item);
        if (cloneInventory?.id) {
            delete cloneInventory.id;
        }
        const v: IInventory = {
            ...cloneInventory,
            parent_code: item?.id,
            ad_platform: AD_PLATFORM_INVENTORY_TYPE_DIGITAL_CAMP,
            ad_tracking_code: '',
            ad_sub_id: '',
            ad_id: '',
            configs: {
                ...cloneInventory?.configs,
                target_ctr: 15,
                hidden_ads_count: 3,
            }
        } as IInventory;
        setIsEditMultiInventory((_prev) => false);
        setInventoryDetail((prev) => v);
    }

    // Begin:: update memo
    const [itemUpdateMemo, setItemUpdateMemo] = useState<{ id: number, memo: string } | null>(null);
    const [isLoadingUpdateMemo, setIsLoadingUpdateMemo] = useState<boolean>(false);

    const handleUpdateMemo = async () => {
        try {
            if (!itemUpdateMemo) {
                return;
            }
            setIsLoadingUpdateMemo((_prev) => true);
            const response: any = await updateMemoInventory(itemUpdateMemo?.id, { memo: itemUpdateMemo?.memo });
            setIsLoadingUpdateMemo((_prev) => false);
            if (response?.code === 200) {
                setItemUpdateMemo((_prev) => null);
                dispatch(onGetInventories(query));
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoadingUpdateMemo((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }
    // End:: update memo


    const handleActionRefresh = () => {
        dispatch(onGetInventories(query));
    };

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                setIsCallAllOptionLoading((_prev) => true);
                const [resMedia, resAgency, resInventory, resAdvertising, resCoupang, resTypeInventory, resDomain]: any = await Promise.all([getAllMedias(), null, getAllInventories(), null, getAllCoupangs(), getAllTypeInventories(), null]);
                setIsCallAllOptionLoading((_prev) => false);

                const list = ([{ name: t('All'), id: '', website: '', code: '' } as any]).concat(resMedia?.data || []);
                setListMedia((_prev) => list);
                setMediaSearch((_prev) => ({
                    label: list?.filter((item) => String(item?.code || '') === String(query?.media_code || ''))[0]?.name || t('All'),
                    value: `${list?.filter((item) => String(item?.code || '') === String(query?.media_code || ''))[0]?.code || ''}`
                }));

                const list_a = ([{ name: t('All'), id: '', code: '' } as any]).concat(resAgency?.data || []);
                const agency = list_a?.find((item) => String(item?.code || '') === String(query?.agency_code || '')) || null;
                setListAgency((_prev) => list_a);
                setAgencySearch((_prev) => ({
                    label: agency?.name || t('All'),
                    value: agency?.code || '',
                }));

                const list_t = resTypeInventory?.data || [];
                const type = list_t?.find((item: any) => String(item?.id || '') === String(query?.inventory_type_id || '')) || null;
                setListTypeInventory((_prev) => list_t);
                setTypeInventorySearch((_prev) => ({
                    label: type?.title || t('All'),
                    value: type?.id || '',
                }));

                const list_d = resDomain?.data || [];
                const domain = list_d?.find((item: any) => String(item?.id || '') === String(query?.domain_id || '')) || null;
                setListDomain((_prev) => list_d);
                setDomainSearch((_prev) => ({
                    label: domain?.domain || t('All'),
                    value: domain?.id || '',
                }));

                const list_i = (resInventory?.data || []);
                setListInventory((_prev) => list_i);

                const list_ad = (resAdvertising?.data || []);
                setListAdvertising((_prev) => list_ad);

                const list_coupang = (resCoupang?.data || []);
                setListCoupang((_prev) => list_coupang);

            } catch (error: any) {
                setIsCallAllOptionLoading((_prev) => false);
                return error;
            }
        };

        handleCallAllOption();
    }, []);

    useEffect(() => {
        // if (mediaSearch) {
        //     setListMedia((_prev) => (_prev || [])?.map((item) => item?.id ? item : ({ ...item, name: t('All') })));
        //     (!mediaSearch?.value) && setMediaSearch((prev) => ({ label: t('All'), value: '' }));
        // }

        // if (agencySearch) {
        //     setListAgency((_prev) => (_prev || [])?.map((item) => item?.id ? item : ({ ...item, name: t('All') })));
        //     (!agencySearch?.value) && setAgencySearch((prev) => ({ label: t('All'), value: '' }));
        // }

        // if (typeInventorySearch) {
        //     (!typeInventorySearch?.value) && setTypeInventorySearch((prev) => ({ label: t('All'), value: '' }));
        // }

        document.title = `${t("Inventory Management")} - ${t("Ads Management")} | AdsHub`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Inventory Management')} pageTitle={t('Ads Management')} />
                    {isHavePermissionRole(ROLES_FOR_APP.MANAGEMENT_INVENTORY, userPermissions) ? (
                        <Row>
                            <Col sm={12} md={12}>
                                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                                    <CardHeader className="border-0">
                                        <Row className="g-4 align-items-center">
                                            <div className="col-sm">
                                                <div>
                                                    <h5 className="card-title mb-0">
                                                        <span className="me-2">{t('Total')}:</span>
                                                        {
                                                            isInventoryLoading ? <Spinner size="sm" className="text-primary" ></Spinner> : (
                                                                <CountUp
                                                                    start={0}
                                                                    end={inventories?.count?.total_inventories || 0}
                                                                    duration={1}
                                                                    className="text-primary"
                                                                />
                                                            )
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                            {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_CREATE, userPermissions) && (<div className="col-sm-auto">
                                                <div>
                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-primary add-btn rounded-pill me-3 mb-2 mb-sm-0"
                                                        id="create-btn"
                                                        onClick={() => setIsShowModalCommonSetting((_prev) => true)}
                                                    >
                                                        <i className="ri-settings-4-line align-bottom me-1"></i>
                                                        {t('Common Settings')}
                                                    </button> */}
                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-primary add-btn rounded-pill me-3 mb-2 mb-sm-0"
                                                        id="create-btn"
                                                        onClick={() => setIsShowModalAssignAutomaticRedirect((_prev) => true)}
                                                    >
                                                        <i className="ri-settings-4-line align-bottom me-1"></i>
                                                        {t('Assign Automatic Redirect')}
                                                    </button> */}
                                                    {/* <button
                                                        type="button"
                                                        className="btn btn-info add-btn rounded-pill me-3 mb-2 mb-sm-0"
                                                        id="create-btn"
                                                        onClick={() => setIsShowModalTypeManagement((_prev) => true)}
                                                    >
                                                        {t('Type Management')}
                                                    </button> */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                                        id="create-btn"
                                                        onClick={() => {
                                                            setIsEditMultiInventory((_prev) => false);
                                                            setInventoryDetail((_prev) => ({} as IInventory));
                                                        }}
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>
                                                        {t('Button Create Inventory')}
                                                    </button>
                                                </div>
                                            </div>)}
                                        </Row>
                                    </CardHeader>
                                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-3">
                                        <div className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics mb-3" style={{ maxWidth: '100%' }}>
                                            {/* <Card className="card-animate mb-0 me-0 me-md-3 mb-0 mb-md-1 bg-primary-subtle text-primary border-0">
                                                <CardBody>
                                                    <div className="d-flex align-items-center ">
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="text-uppercase fw-medium text-primary text-truncate mb-0">{t('Fill-Rate')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end justify-content-between mt-2 pt-1">
                                                        <div>
                                                            <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                                                                <span className="counter-value text-primary">
                                                                    {isInventoryLoading ? <Spinner size="sm" ></Spinner> : (
                                                                        <CountUp
                                                                            start={0}
                                                                            end={inventories?.count?.fill_rate_count || 0}
                                                                            duration={1}
                                                                        />
                                                                    )}
                                                                </span></h4>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> */}
                                            {/* <Card className="card-animate mb-0 me-0 me-md-3 mb-0 mb-md-1 bg-primary-subtle text-primary border-0">
                                                <CardBody>
                                                    <div className="d-flex align-items-center ">
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="text-uppercase fw-medium text-primary text-truncate mb-0">{t('Click Option')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end justify-content-between mt-2 pt-1">
                                                        <div>
                                                            <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                                                                <span className="counter-value text-primary">
                                                                    {isInventoryLoading ? <Spinner size="sm" ></Spinner> : (
                                                                        <CountUp
                                                                            start={0}
                                                                            end={inventories?.count?.click_count || 0}
                                                                            duration={1}
                                                                        />
                                                                    )}
                                                                </span></h4>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> */}
                                            {/* <Card className="card-animate mb-0 me-0 me-md-3 mb-0 mb-md-1 bg-primary-subtle text-primary border-0">
                                                <CardBody>
                                                    <div className="d-flex align-items-center ">
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="text-uppercase fw-medium text-primary text-truncate mb-0">{t('Size Option')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end justify-content-between mt-2 pt-1">
                                                        <div>
                                                            <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                                                                <span className="counter-value text-primary">
                                                                    {isInventoryLoading ? <Spinner size="sm" ></Spinner> : (
                                                                        <CountUp
                                                                            start={0}
                                                                            end={inventories?.count?.banner_size_count || 0}
                                                                            duration={1}
                                                                        />
                                                                    )}
                                                                </span></h4>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> */}
                                            {/* <Card className="card-animate mb-0 me-0 me-md-3 mb-0 mb-md-1 bg-primary-subtle text-primary border-0">
                                                <CardBody>
                                                    <div className="d-flex align-items-center ">
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="text-uppercase fw-medium text-primary text-truncate mb-0">{t('Block Referral')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end justify-content-between mt-2 pt-1">
                                                        <div>
                                                            <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                                                                <span className="counter-value text-primary">
                                                                    {isInventoryLoading ? <Spinner size="sm" ></Spinner> : (
                                                                        <CountUp
                                                                            start={0}
                                                                            end={inventories?.count?.block_referral_count || 0}
                                                                            duration={1}
                                                                        />
                                                                    )}
                                                                </span></h4>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> */}
                                            {/* <Card className="card-animate mb-0 me-0 me-md-3 mb-0 mb-md-1 bg-primary-subtle text-primary border-0">
                                                <CardBody>
                                                    <div className="d-flex align-items-center ">
                                                        <div className="flex-grow-1 overflow-hidden">
                                                            <p className="text-uppercase fw-medium text-primary text-truncate mb-0">{t('Block Keyword')}</p>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-end justify-content-between mt-2 pt-1">
                                                        <div>
                                                            <h4 className="fs-22 fw-semibold ff-secondary mb-0">
                                                                <span className="counter-value text-primary">
                                                                    {isInventoryLoading ? <Spinner size="sm" ></Spinner> : (
                                                                        <CountUp
                                                                            start={0}
                                                                            end={inventories?.count?.except_keyword_count || 0}
                                                                            duration={1}
                                                                        />
                                                                    )}
                                                                </span></h4>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card> */}
                                        </div>
                                        <Row className="g-4 align-items-center mt-0">
                                            {/* <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Agency')} isShow={true}>
                                                    <DropdownAgency
                                                        name="agency"
                                                        typeValue="code"
                                                        dataList={listAgency}
                                                        initialValue={agencySearch}
                                                        onChangeSelect={(event: any) => {
                                                            setAgencySearch((_prev) => event);
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}

                                            {/* <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Media Type')} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_type"
                                                        dataList={TYPE_MEDIA_OPTIONS_LANG}
                                                        placeholder={`${t('Media Type')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={mediaTypeSearch || null}
                                                        onChangeSelect={(e: any) => setMediaTypeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}

                                            <Col sm={12} md={6} xl={3} xxl={3} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Media')} isShow={true}>
                                                    <DropdownMedia
                                                        name="medias"
                                                        typeValue="code"
                                                        dataList={listMedia}
                                                        initialValue={mediaSearch}
                                                        onChangeSelect={(event: any) => {
                                                            setMediaSearch((_prev) => event);
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            {/* <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Domain')} isShow={true}>
                                                    <DropdownOption
                                                        name="domain_id"
                                                        dataList={listDomain?.map((item) => ({ value: String(item?.id), label: item?.domain }))}
                                                        placeholder={`${t("Domain")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={domainSearch || null}
                                                        onChangeSelect={(event: any) => {
                                                            setDomainSearch((_prev) => event);
                                                        }}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t("Ad Platform")} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_platform"
                                                        dataList={AD_PLATFORM_INVENTORY_OPTIONS_LANG || []}
                                                        placeholder={`${t("Ad Platform")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={adPlatformSearch || null}
                                                        onChangeSelect={(e: any) => setAdPlatformSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}


                                            {/* <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Type Of Inventory In Filter')} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_type"
                                                        dataList={listTypeInventory?.map((item) => ({ value: String(item?.id), label: item?.title }))}
                                                        placeholder={`${t('Type Of Inventory In Filter')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={typeInventorySearch || null}
                                                        onChangeSelect={(e: any) => setTypeInventorySearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Inventory Type')} isShow={true}>
                                                    <DropdownOption
                                                        name="inventory_type"
                                                        dataList={TYPE_INVENTORY_OPTIONS_LANG || []}
                                                        placeholder={`${t("Inventory Type")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={typeSearch || TYPE_INVENTORY_OPTIONS_LANG[0]}
                                                        onChangeSelect={(e: any) => setTypeSearch(e)}
                                                        isHasOptionAll={false}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Fill-Rate')} isShow={true}>
                                                    <DropdownOption
                                                        name="fill_rate"
                                                        dataList={STATUS_SETTING_OPTIONS_LANG || []}
                                                        placeholder={`${t("Fill-Rate")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={fillRateSearch || null}
                                                        onChangeSelect={(e: any) => setFillRateSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Setting'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Click Option')} isShow={true}>
                                                    <DropdownOption
                                                        name="flg_click"
                                                        dataList={STATUS_SETTING_OPTIONS_LANG || []}
                                                        placeholder={`${t("Click Option")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={flgClickSearch || null}
                                                        onChangeSelect={(e: any) => setFlgClickSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Setting'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Size Option')} isShow={true}>
                                                    <DropdownOption
                                                        name="flg_banner_size"
                                                        dataList={STATUS_SETTING_OPTIONS_LANG || []}
                                                        placeholder={`${t("Size Option")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={flgBannerSizeSearch || null}
                                                        onChangeSelect={(e: any) => setFlgBannerSizeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Setting'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Block Referral')} isShow={true}>
                                                    <DropdownOption
                                                        name="is_block_referral"
                                                        dataList={STATUS_SETTING_OPTIONS_LANG || []}
                                                        placeholder={`${t("Block Referral")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={isBlockReferralSearch || null}
                                                        onChangeSelect={(e: any) => setIsBlockReferralSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Setting'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Block Keyword')} isShow={true}>
                                                    <DropdownOption
                                                        name="is_except_keyword"
                                                        dataList={STATUS_SETTING_OPTIONS_LANG || []}
                                                        placeholder={`${t("Block Keyword")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={isExceptKeywordSearch || null}
                                                        onChangeSelect={(e: any) => setIsExceptKeywordSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Setting'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Force Click (Layer & Slider)')} isShow={true}>
                                                    <DropdownOption
                                                        name="is_automatic_click"
                                                        dataList={STATUS_FORCE_CLICK_OPTIONS_LANG || []}
                                                        placeholder={`${t("Force Click (Layer & Slider)")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={isAutomaticClickSearch || null}
                                                        onChangeSelect={(e: any) => setIsAutomaticClickSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Ad Type')} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_type"
                                                        dataList={AD_TYPE_INVENTORY_OPTIONS_LANG}
                                                        placeholder={`${t('Ad Type')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={adTypeSearch || null}
                                                        onChangeSelect={(e: any) => setAdTypeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={4} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Banner Type')} isShow={true}>
                                                    <DropdownOption
                                                        name="ad_type"
                                                        dataList={BANNER_TYPE_INVENTORY_OPTIONS_LANG}
                                                        placeholder={`${t('Banner Type')}...`}
                                                        className="search-filter-category-type dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={bannerTypeSearch || null}
                                                        onChangeSelect={(e: any) => setBannerTypeSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All'), value: '' }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}

                                            {/* <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Tracking Code')} isShow={!!trackingCodeSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Tracking Code')}...`}
                                                        value={trackingCodeSearch}
                                                        onChange={(e) => setTrackingCodeSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Sub ID')} isShow={!!subIdSearch}>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t('Sub ID')}...`}
                                                        value={subIdSearch}
                                                        onChange={(e) => setSubIdSearch(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </LabelWrapper>
                                            </Col> */}


                                            <Col sm={12} md={6} xl={2} xxl={2} className='mt-3 mt-md-2 mb-2'>
                                                <LabelWrapper label={t('Status')} isShow={!!statusSearch?.value}>
                                                    <DropdownStatus
                                                        name="status"
                                                        dataList={STATUS_INVENTORY_OPTIONS_LANG || []}
                                                        placeholder={`${t("Status")}...`}
                                                        className="dropdown-status-rounded"
                                                        classNamePrefix="name-prefix"
                                                        initialValue={statusSearch || null}
                                                        onChangeSelect={(e: any) => setStatusSearch(e)}
                                                        isHasOptionAll={true}
                                                        optionAll={{ label: t('All Status'), value: '' }}
                                                        colors={['danger', 'success']}
                                                    />
                                                </LabelWrapper>
                                            </Col>

                                            <Col sm={12} md={12} xl={4} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-xl-start mt-3 mt-md-2 mb-2 order-1 order-sm-0">
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary me-2 "
                                                        onClick={searchData}
                                                        disabled={(isInventoryLoading || isCallAllOptionLoading)}
                                                    >
                                                        {(isInventoryLoading || isCallAllOptionLoading) ? <div className="me-1" style={{ display: 'inline-table', verticalAlign: 'top' }}><Spinner size="sm" style={{ width: '14px', height: '14px' }}></Spinner></div> : <i className="ri-search-line align-bottom me-1"></i>}{" "}
                                                        {t('Button Search')}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary fs-14"
                                                        onClick={resetData}
                                                    >
                                                        <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                        {t('Button Reset')}
                                                    </button>
                                                </div>
                                            </Col>
                                            {/* <Col sm={12} md={12} lg={12} xl={12} className="hstack gap-1 justify-content-end justify-content-sm-start mt-4 mt-md-2 mb-2 order-2 order-sm-0">
                                                <div className="w-100 d-flex justify-content-between justify-content-sm-start gap-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-light add-btn mb-2 mb-sm-0"
                                                        id="create-btn"
                                                        onClick={() => setIsShowConfigDisplayInventory((_prev) => true)}
                                                    >
                                                        <i className="ri-layout-left-2-line  align-bottom me-1"></i>
                                                        {t('Config Display')}
                                                    </button>
                                                    {isHavePermissionRole(ROLES_FOR_APP.INVENTORY_UPDATE, userPermissions) && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary add-btn mb-2 mb-sm-0"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setIsEditMultiInventory((_prev) => true);
                                                                setInventoryDetail((_prev) => ({} as IInventory));
                                                            }}
                                                            disabled={countRowSelected <= 0}
                                                        >
                                                            {countRowSelected > 0 && (
                                                                <span className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                                                    style={{ transform: 'translate(0%, -70%)' }}
                                                                >
                                                                    {formatNumberWithCommas(countRowSelected)}
                                                                    <span className="visually-hidden">total keywords selected</span>
                                                                </span>)}
                                                            <i className="ri-pencil-fill me-1"></i>
                                                            {t('Button Edit Multi Inventory')}
                                                        </button>
                                                    )}
                                                </div>
                                            </Col> */}
                                        </Row>
                                    </div>
                                    <CardBody className="pt-3">
                                        <TableInventory
                                            className="custom-header-css"
                                            divClass="table-responsive table-card"
                                            tableClass="align-middle table-bordered-dashed sticky-table-inventory"
                                            theadClass="table-light text-muted"
                                            columns={columns}
                                            data={inventories?.list?.length ? inventories?.list : []}
                                            customPageSize={query.limit}
                                            customPageIndex={query.page - 1}
                                            totalRecords={inventories?.pagination?.total}
                                            customPageCount={Math.ceil(Number(inventories?.pagination?.total) / Number(inventories?.pagination?.limit))}
                                            handleChangePage={handleChangePage}
                                            manualSorting={true}
                                            sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                            handleChangeSorting={handleChangeSorting}
                                            configDisplay={configDisplayInventory}
                                            isLoading={isInventoryLoading}
                                            handleCreateSubInventoryFrom={handleCreateSubInventoryFrom}
                                            handleShowConfirmUpdateConfig={handleShowConfirmUpdateConfig}
                                            setItemUpdateMemo={setItemUpdateMemo}
                                            setInventoryDetail={setInventoryDetail}
                                            setInventoryShowCPM={setInventoryShowCPM}
                                            setInventoryHistories={setInventoryHistories}
                                            handleConfirmDelete={handleConfirmDelete}
                                            isChecked={isChecked}
                                            handleCheck={handleCheck}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                            {(windowSize?.width >= MAX_WIDTH_SCREEN) && (
                                <Offcanvas
                                    fade
                                    scrollable={false}
                                    direction="end"
                                    isOpen={(inventoryDetail !== null)}
                                    id="offcanvasExample"
                                    className='off-canvas-lg off-canvas-lg-600'
                                >
                                    <OffcanvasHeader className="bg-light" toggle={handleCloseModalFormInventory}>
                                        <h5 className="fs-16 mb-1">{isEditMultiInventory ? t('Edit Multi Inventory') : (!!inventoryDetail?.id ? (inventoryDetail?.is_preview ? t('Button Detail Inventory') : t('Button Update Inventory')) : t('Button Create Inventory'))}</h5>
                                    </OffcanvasHeader>
                                    <OffcanvasBody className="color-scrollbar-os">
                                        <FormInventory isEditMulti={isEditMultiInventory} inventoryIds={optionsSelectedValue} medias={listMedia} agencies={(listAgency || [])?.filter((item) => !!item?.id)} coupangs={listCoupang} inventories={listInventory} advertising={listAdvertising} types={listTypeInventory} domains={listDomain} detail={inventoryDetail} triggerRefresh={handleRefresh} handleClose={() => handleCloseModalFormInventory()} />
                                    </OffcanvasBody>
                                </Offcanvas>
                            )}
                            {(windowSize?.width < MAX_WIDTH_SCREEN) && (<Modal
                                isOpen={inventoryDetail !== null}
                                centered={true}
                                size="md"
                                toggle={() => handleCloseModalFormInventory()}
                                keyboard={true}
                            >
                                <ModalHeader toggle={() => handleCloseModalFormInventory()}>
                                    {isEditMultiInventory ? t('Edit Multi Inventory') : (!!inventoryDetail?.id ? (inventoryDetail?.is_preview ? t('Button Detail Inventory') : t('Button Update Inventory')) : t('Button Create Inventory'))}
                                </ModalHeader>
                                <ModalBody className="">
                                    <FormInventory isEditMulti={isEditMultiInventory} inventoryIds={optionsSelectedValue} medias={listMedia} agencies={(listAgency || [])?.filter((item) => !!item?.id)} coupangs={listCoupang} inventories={listInventory} advertising={listAdvertising} types={listTypeInventory} domains={listDomain} detail={inventoryDetail} triggerRefresh={handleRefresh} handleClose={() => handleCloseModalFormInventory()} />
                                </ModalBody>
                            </Modal>)}
                        </Row>
                    ) : <></>}
                    <ToastContainer closeButton={false} limit={1} />
                </Container>
            </div>
            <Modal
                isOpen={itemUpdateMemo !== null}
                centered={true}
                size="md"
                toggle={() => setItemUpdateMemo((_prev) => null)}
                keyboard={true}
            >
                <ModalHeader toggle={() => setItemUpdateMemo((_prev) => null)}>
                    {t('Button Update Memo')}
                </ModalHeader>
                <ModalBody className="">
                    <Col md={12} lg={12}>
                        <div>
                            <label className="form-label">
                                {t("Memo")}
                                <span className="text-danger"> *</span>
                            </label>
                            <Input
                                type="textarea"
                                rows={3}
                                id="memo"
                                name="memo"
                                autocomplete={false}
                                value={itemUpdateMemo?.memo}
                                placeholder={`${t("Memo")}...`}
                                onChange={(event: any) => {
                                    setItemUpdateMemo((prev: any) => ({ ...prev, memo: event?.target?.value || '' }))
                                }}
                            />
                        </div>
                    </Col>
                    <Col lg={12}>
                        <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                            <button
                                className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                                color="light"
                                type="button"
                                disabled={isLoadingUpdateMemo}
                                style={{ width: '100px' }}
                                onClick={() => setItemUpdateMemo((_prev) => null)}
                            >
                                {t("Button Close")}
                            </button>
                            <button
                                className="btn btn-primary rounded-pill fs-14"
                                color="success"
                                type="button"
                                disabled={isLoadingUpdateMemo}
                                style={{ width: '150px' }}
                                onClick={() => handleUpdateMemo()}
                            >
                                {isLoadingUpdateMemo ? (
                                    <Spinner size="sm" className="me-2"></Spinner>
                                ) :
                                    <> {t("Button Update")}</>}
                            </button>
                        </div>
                    </Col>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={inventoryHistories !== null}
                centered={true}
                size="lg"
                toggle={() => setInventoryHistories((_prev) => null)}
                keyboard={true}
            >
                <ModalHeader toggle={() => setInventoryHistories((_prev) => null)}>
                    {t('Button Ad Information History')}
                </ModalHeader>
                <ModalBody className="">
                    <Col md={12} lg={12}>
                        <InventoryHistory inventoryId={inventoryHistories?.id} />
                    </Col>
                    <Col lg={12}>
                        <div className="hstack gap-2 justify-content-sm-center justify-content-md-end mt-3">
                            <button
                                className="btn btn-soft-secondary rounded-pill fs-14 me-2"
                                color="light"
                                type="button"
                                disabled={isLoadingUpdateMemo}
                                style={{ width: '100px' }}
                                onClick={() => setInventoryHistories((_prev) => null)}
                            >
                                {t("Button Close")}
                            </button>
                        </div>
                    </Col>
                </ModalBody>
            </Modal>
            <Modal
                isOpen={!!isShowModalAssignAutomaticRedirect}
                toggle={() => setIsShowModalAssignAutomaticRedirect((_prev) => false)}
                keyboard={false}
                centered={true}
                size="xl"
                className="modal-fullscreen"
                scrollable={false}
            >
                <ModalHeader toggle={() => setIsShowModalAssignAutomaticRedirect((_prev) => false)}>
                    {t('Assign Automatic Redirect')}
                </ModalHeader>
                <ModalBody className="">
                    <Row>
                        <AssignAutomaticRedirect medias={listMedia} triggerRefresh={handleRefresh} handleClose={() => setIsShowModalAssignAutomaticRedirect((_prev) => false)} />
                    </Row>
                </ModalBody>
            </Modal>

            <ModalCommonSetting
                isOpen={isShowModalCommonSetting}
                onClose={() => setIsShowModalCommonSetting((_prev) => false)}
            />

            <Modal
                isOpen={!!isShowModalTypeManagement}
                toggle={() => setIsShowModalTypeManagement((_prev) => false)}
                keyboard={false}
                centered={true}
                size="xl"
                className="modal-fullscreen"
                scrollable={false}
            >
                <ModalHeader toggle={() => setIsShowModalTypeManagement((_prev) => false)}>
                    {t('Type Management')}
                </ModalHeader>
                <ModalBody className="">
                    <Row>
                        <TypeInventory triggerRefresh={handleRefreshTypeInventory} handleClose={() => setIsShowModalTypeManagement((_prev) => false)} />
                    </Row>
                </ModalBody>
            </Modal>



            <Modal isOpen={!!inventoryShowCPM} centered={true} scrollable={true} size="xl modal-xxll">
                <ModalHeader toggle={() => setInventoryShowCPM((prev: any) => (prev ? null : prev))}>
                    {t('Button Config CPM')}
                </ModalHeader>
                <ModalBody className="py-3 pt-0 px-4">
                    <div style={{ minHeight: '450px' }}>
                        <Row>
                            <Col md={12} lg={6}>
                                <ConfigInventoryCPM
                                    inventoryId={inventoryShowCPM?.id}
                                    inventory={inventoryShowCPM}
                                    handleActionRefresh={handleActionRefresh}
                                    handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                />
                            </Col>
                            <Col md={12} lg={6}>
                                <ConfigAgencyCPM
                                    inventoryId={inventoryShowCPM?.id}
                                    agencyCode={inventoryShowCPM?.inventoryAgency?.agency_code}
                                    inventory={inventoryShowCPM}
                                    handleActionRefresh={handleActionRefresh}
                                    handleCloseModal={() => setInventoryShowCPM((prev: any) => (null))}
                                />
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>

            <ConfigDisplayInventory
                isOpen={isShowConfigDisplayInventory}
                onClose={() => setIsShowConfigDisplayInventory(() => false)}
                onTriggerRefresh={() => { }}
            />

            <ModalConfirm
                header={t('Button Delete Inventory')}
                isOpen={idDelete !== null}
                isLoading={isConfirmLoading}
                onClose={onCloseConfirmClick}
                onConfirm={handleActionDelete}
            />
            <ModalConfirm
                textButtonConfirm={t('Button Update')}
                classButtonConfirm='btn-primary'
                classIconButtonConfirm=''
                header={(itemUpdate?.data?.status || itemUpdate?.data?.flg_banner_size || itemUpdate?.data?.flg_click || itemUpdate?.data?.fill_rate || itemUpdate?.data?.is_block_referral || itemUpdate?.data?.is_except_keyword) ? t('Confirm to ON') : t('Confirm to OFF')}
                title={t('Are you sure you want to update this?')}
                content={t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                isShowIcon={false}
                isOpen={!!itemUpdate}
                isLoading={isLoadingUpdate}
                onClose={() => setItemUpdate((prev: any) => null)}
                onConfirm={handleOnConfirmUpdate}
            />
        </React.Fragment>
    );
};

export default ManagementInventory;